import './Pages.css';
import '../css/navbarchap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useEffect} from "react";
import PDFViewerComponent from '../components/PDFViewerComponent';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const Chapitre4sc2partA = () => {
   
    useEffect(() => {
        document.body.classList.add('no-scroll'); // Ajoutez la classe no-scroll au body
        return () => {
          document.body.classList.remove('no-scroll'); // Retirez la classe no-scroll du body lorsque le composant est démonté
        };
      }, []);

const navigate = useNavigate();

    return (
      <div className="Chapitre">
        <Navbar expand="lg">
            <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav">
                <span className='navbar-toggler-nav'></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto">
                <Nav.Link href="" className={ 'navbar-link'} onClick={() => navigate('/chapitre4sc1partb')}>Chapitre précédent
                  <div className="small-italic">B.   Voyage à vélo en<br/>Bretagne l'été 1932</div>
                </Nav.Link>
                <Nav.Link href="#sommaire" className={  'navbar-link'} onClick={() => navigate('/')}>Retour au sommaire
                  <div className="small-italic">Sous-chapitre 2 -<br/>Le journaliste à "L'Echo Rochelais"</div>
                </Nav.Link>
                <Nav.Link href="" className={'navbar-link'} onClick={() => navigate('/chapitre4sc2partb')}>Chapitre suivant
                  <div className="small-italic">B.  Le localier fait "le Badaud"</div>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>
          <div className="PDF-viewer-container">
			      <PDFViewerComponent
				      document={`${process.env.PUBLIC_URL}chapitre4sc2parta.pdf`}
			      />
		    </div>
      </div>
    );
  };
export default Chapitre4sc2partA;
  

